import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import CompanyUserGroup from "./CompanyUserGroup";
import GridConfig from "../GridConfig";
import { Header } from '../Header';
import { Footer } from '../Footer';

export default class CompanyUserGroups extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            companyId: props.CompanyId,
            controllerName: 'company/usergroup',
            data: null,
            loading: true,
            configName: 'companyusers_grid',
            moduleName: 'گروه کاربران',
            menuId: 93
        };
        this.state.filters = {
            companyId: this.state.companyId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CompanyUserGroup Caller={this} Id={id} CompanyId={this.state.companyId} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <CompanyUserGroup Caller={this} CompanyId={this.state.companyId} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "title", caption: "نام", show: true },
                { field: "createDatePersian", caption: "تاریخ ثبت", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'title' && f.show) t.push({ field: f.field, flex: 4, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.title}</a> } });
            if (f.field == 'createDatePersian' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        t.push({
            field: 'id', filter: false, headerName: 'عملیات', cellRenderer: (props) => {
                return [
                    <a className="hand text-danger" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove"><em className="icon ni ni-trash"></em><span>حذف</span></a>
                ]
            }
        });
        return t;
    }  
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();

        return (
            <div>
                <div className="nk-content-body">
                    <div className="nk-block">
                        {this.getToolBar(false, {
                            add: true, print: false, pdf: false, excell: false, remove: false, config: false,
                            otherFilters: null
                        })}
                        {this.renderAgGrid({
                            columnDefs: this.getColumns()
                        })}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}